import { Box } from '@mui/material';
import { useSearchParams } from 'react-router';

import { useAnalytics } from '~/analytics';
import AttachmentUploader from '~/components/AttachmentUploader';
import SelectUploadDocumentTypeDialog from '~/components/uploadDocument/SelectDocumentTypeDialog';
import SuccessDocumentDialog from '~/components/uploadDocument/SuccessDocumentDialog';
import { useUploadDocumentFlow } from '~/components/uploadDocument/UploadDocumentDialogFlow';

interface ComplianceDocumentUploadProps {
  onCertificateAdded?: () => void;
  onClick?: () => void;
  propertyId?: string;
  carId?: string;
}

export const ComplianceDocumentUpload: React.FC<ComplianceDocumentUploadProps> = ({
  onCertificateAdded,
  onClick,
  propertyId,
  carId,
}) => {
  const uploadDocumentFlowProvider = useUploadDocumentFlow();
  const { state, onFilesUploaded, onDocumentFlowDone, goBack, reset } = uploadDocumentFlowProvider;

  const [, setSearchParams] = useSearchParams();
  const { track } = useAnalytics();

  const handleAddDocument = () => {
    if (propertyId && carId) {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set('propertyId', propertyId);
        newParams.set('carId', carId);
        return newParams;
      });
    }
  };

  const handleOnCancel = () => {
    goBack();
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.delete('propertyId');
      newParams.delete('carId');
      return newParams;
    });
  };

  return (
    <Box onClick={onClick}>
      <AttachmentUploader
        fileSizeLimit={5}
        acceptedFileTypes={{ 'application/pdf': ['.pdf'] }}
        acceptedFileTypesLabel="PDF"
        onFilesUploaded={(attachments) => {
          onFilesUploaded(attachments);
          handleAddDocument();
        }}
      />

      {state.name === 'processDocuments' && (
        <SelectUploadDocumentTypeDialog
          open
          onCancel={handleOnCancel}
          onDone={(docs) => {
            onDocumentFlowDone(docs);
            track('certificate_uploaded', { status: 'success', count: docs.length });
            onCertificateAdded?.();
          }}
          documents={state.documents}
        />
      )}

      {state.name === 'success' && (
        <SuccessDocumentDialog
          documentsAdded={state.documents}
          onClose={() => {
            reset();
            onCertificateAdded?.();
          }}
        />
      )}
    </Box>
  );
};
